import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";
import type { PropsWithChildren, ReactElement } from "react";
import { Home } from "lucide-react";
import { ErrorState } from "@/components/common/ErrorState";
import Button from "@/components/ui/Button";

function AppErrorFallback({
  resetError,
}: {
  resetError: () => void;
}): ReactElement {
  const { t } = useTranslation("common");
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-50 px-4">
      <ErrorState
        title={t("appCrashTitle")}
        message={t("appCrashMessage")}
        onRetry={resetError}
        action={
          <Button
            type="button"
            variant="outline"
            leftIcon={<Home className="h-4 w-4" />}
            onClick={() => {
              window.location.assign("/");
            }}
          >
            {t("goHome")}
          </Button>
        }
      />
    </div>
  );
}

export function AppErrorBoundary({
  children,
}: PropsWithChildren): ReactElement {
  return (
    <Sentry.ErrorBoundary
      showDialog={false}
      fallback={({ resetError }) => (
        <AppErrorFallback resetError={resetError} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
